import React from "react";
import Name from "./Fields/Name/Name";
import Avatar from "Components/common/Avatar/Avatar";
import AccountLead from "./Fields/AccountLead/AccountLead";
import Color from "./Fields/Color/Color";
import Picture from "./Fields/Picture/Picture";
import AccountEmail from "./Fields/AccountEmail/AccountEmail";
import { FALLBACK_EMAIL } from "Source/components/project/Config/Config";
import AccountEmailInput from "./Fields/AccountEmail/AccountEmailInput";
import { createValidationRule, maxLengthRule, validCFOEmailRule, validEmailInputRule } from "@/src/util/form/form.rules";
import { checkProjectExistingEmail } from "@/src/reducers/project/project/project.service";
import { EMAIL_SUFFIX } from "@/src/components/project/Config/Config";

export const getFields = (props) => [
    {
        id: "project",
        fieldClass: "semiLargeWidth",
        label: "Account Name",
        placeholder: "Account Name",
        defaultValue: props.selected.project,
        value: props.state.fields.project,
        required: true,
        component: (
            <Name
                value={props.state.fields.project}
                projectId={props.selected.id}
                error={props.state.error}
                onInputChange={e => props.onUpdateAccountName({
                    target: { id: "project", value: e.name },
                    error: e.error
                })}
            />
        )
    },
    {
        id: "accountType",
        fieldClass: "",
        label: "Account Type",
        placeholder: "Account Type",
        defaultValue: (
            <div class="typeContainer">
                {props.selected.typeId === 1 ? "Company" : props.selected.type.type}
            </div>
        ),
        displayOnly: true
    },
    {
        id: "createdBy",
        fieldClass: "",
        label: "Created By",
        placeholder: "Created By",
        defaultValue: (
            <div class="userContainer">
                <Avatar id={props.selected.creator.id} name={`${props.selected.creator.firstName} ${props.selected.creator.lastName}`} disableTooltip={true} />
                {`${props.selected.creator.firstName} ${props.selected.creator.lastName}`}
            </div>
        ),
        displayOnly: true
    },
    {
        id: "accountLead",
        fieldClass: "semiLargeWidth",
        label: "Account Lead",
        placeholder: "Account Lead",
        defaultValue: props.selected.lead && (
            <div className="userContainer">
                <Avatar
                    id={props.selected.lead.id}
                    name={`${props.selected.lead.firstName} ${props.selected.lead.lastName}`}
                    disableTooltip={true}
                />
                {`${props.selected.lead.firstName} ${props.selected.lead.lastName}`}
            </div>
        ),
        component: (
            <AccountLead
                selected={props.state.fields.accountLead}
                onSelectLead={option =>
                    props.onUpdateFields({
                        target: { id: "accountLead", value: option },
                    })
                }
            />
        ),
        required: true,
    },
    {
        id: "accountEmail",
        fieldClass: "",
        label: "Account Email",
        placeholder: "Account Email",
        defaultValue: <AccountEmail email={props.selected.email || FALLBACK_EMAIL} isEdit={props.state.layout === 'form'} />,
        ...(props.isAdmin && { component: <AccountEmailInput fieldEmailProps={props.fieldEmailProps} /> }),
        displayOnly: !props.isAdmin,
    },
    {
        id: "color",
        fieldClass: "extraSmallWidth",
        label: "Color Indicator",
        placeholder: "Color Indicator",
        defaultValue: (
            <div class="colorIndicator">
                <div class="box" style={{ backgroundColor: props.selected.color }}></div>
                <span style={{ color: props.selected.color }}>{props.selected.color}</span>
            </div>
        ),
        component: (
            <Color
                color={props.state.fields.color}
                onChangeColor={color => props.onUpdateFields({ target: { id: "color", value: color.hex } })}
            />
        ),
        required: true
    },
    {
        id: "image",
        fieldClass: "",
        label: "Image",
        placeholder: "Edit to upload",
        defaultValue: props.selected.picture ? (
            <img src={`/api/file/project_pictures/${props.selected.picture}`} alt={props.selected.project} />
        ) : null,
        component: (
            <Picture
                avatar={`/api/file/project_pictures/${props.selected.picture}`}
                onChange={e => props.onUpdateFields({ target: { id: "picture", value: e } })}
            />
        )
    }
]

export function emailExistsRule({ projectId, message }) {
    return createValidationRule(
        "emailExists",
        message,
        async (inputValue, inputObj) => {
            const currentEmail = `${inputObj.email.defaultValue}@${EMAIL_SUFFIX}`;
            const inputEmail = `${inputValue}@${EMAIL_SUFFIX}`;

            if (currentEmail === inputEmail) {
                return true;
            }

            return await checkProjectExistingEmail({ projectId, email: inputEmail });
        }
    );
}


export const saveCompanyForm = {
    email: {
        validationRules: (projectId) => [
            maxLengthRule("email", 300),
            validEmailInputRule("email"),
            validCFOEmailRule("email"),
            emailExistsRule({ projectId, message: 'Email already assigned to another account!' }),
        ],
    }
};

